import { render, staticRenderFns } from "./PreDefinedAmounts.vue?vue&type=template&id=24b3168e"
import script from "./PreDefinedAmounts.vue?vue&type=script&lang=js"
export * from "./PreDefinedAmounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\lifeline-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b3168e')) {
      api.createRecord('24b3168e', component.options)
    } else {
      api.reload('24b3168e', component.options)
    }
    module.hot.accept("./PreDefinedAmounts.vue?vue&type=template&id=24b3168e", function () {
      api.rerender('24b3168e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/PreDefinedAmounts.vue"
export default component.exports